// The Bloomreach API-documented placeholder — the schema default from get-autosuggestions.md.
// Used only when the real cookie is absent (cookie consent denied, BrTrk blocked, or a
// non-browser environment). Callers must NOT re-encode this value; it is already pre-encoded.
//
// Also exported for buildBloomreachCacheKey in query-builders.ts, which must produce a stable
// URL key regardless of when BrTrk writes the real _br_uid_2 cookie.
export const PLACEHOLDER_BR_UID = "uid%3D7797686432023%3Av%3D11.5%3Ats%3D1428617911187%3Ahc%3D55";

/**
 * Reads the Bloomreach first-party device ID (_br_uid_2) from document.cookie.
 *
 * The cookie value is pre-encoded (format: `uid%3DN%3Av%3DN%3Ats%3DN%3Ahc%3DN`) and must be
 * passed verbatim to Bloomreach APIs. The serialiser in query-builders.ts has a special
 * passthrough for _br_uid_2 that skips encodeURIComponent for exactly this reason.
 *
 * Falls back to the API placeholder only when the cookie is absent.
 *
 * @see query-builders.ts — serializeBloomreachParams passthrough
 * @see docs/bloomreach-uid-cookie-2026-06-12/ticket.md — latent bug this fixes
 */
export function readBrUid(): string {
  if (typeof document === "undefined") return PLACEHOLDER_BR_UID;
  const match = document.cookie
    .split(";")
    .map((c) => c.trim())
    .find((c) => c.startsWith("_br_uid_2="));
  if (!match) return PLACEHOLDER_BR_UID;
  const value = match.slice("_br_uid_2=".length);
  // Guard against a CMP blanking the cookie (sets "_br_uid_2=" with no value) rather
  // than deleting it — an empty string is neither a valid uid nor the documented placeholder.
  return value || PLACEHOLDER_BR_UID;
}
